var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('amui-financing-popover-content-layout',{attrs:{"header":_vm.header,"body":_vm.body,"foot-notes":_vm.footNotes}})}
var staticRenderFns = []

export { render, staticRenderFns }